import gql from 'graphql-tag';

export default gql`
  mutation markAnnouncementViewed($input: markAnnouncementViewedInput!) {
    markAnnouncementViewed(input: $input) {
      viewer {
        id
        publishedAnnouncement {
          id
          title
          content
          status
          audience
        }
      }
    }
  }
`;
